import { Injectable } from '@angular/core';
import { Permission } from '../../permission/permission';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}
const Permission_TYPE = Permission;
const MENUITEMS = [
  {
    label: 'QUOTATION',
    main: [{
      state: 'list',
      short_label: 'quo',
      main_state: 'quotation',
      name: 'QUOTATION',
      type: 'link',
      icon: '',
      p_type: Permission_TYPE.QUOTATION,//can you change
      children: [
        // {
        //   state: 'dashboard',
        //   short_label: 'D',
        //   name: 'Dashboard',
        //   type: 'sub',
        //   icon: 'ti-home',

        // },
        // {
        //   state: 'navigation',
        //   short_label: 'N',
        //   name: 'Navigation',
        //   type: 'link',
        //   icon: 'ti-layout-cta-right'
        // },

      ],
    }],
  },
  {
    label: 'QUOTATION APPROVAL',
    main: [{
      state: 'list',
      short_label: 'quo apv',
      main_state: 'qo-approval',
      name: 'QUOTATION APPROVAL',
      type: 'link',
      icon: '',
      children: [],
      p_type: Permission_TYPE.QUOTATION_APPROVAL

    }],
  },
  {
    label: 'PRODUCTS',
    main: [{
      state: 'list',
      short_label: 'pd',
      main_state: 'product',
      name: 'PRODUCTS',
      type: 'link',
      icon: '',
      children: [],
      p_type: Permission_TYPE.PRODUCT

    }],
  },
  {
    label: 'TRANSPORTATION',
    main: [{
      state: 'list',
      short_label: 'transport',
      main_state: 'transportation',
      name: 'TRANSPORTATION',
      type: 'link',
      icon: '',
      children: [],
      p_type: Permission_TYPE.TRANSPORTATION//can you change

    }],
  },
  {
    label: 'CUSTOMER',
    main: [{
      state: 'list',
      short_label: 'cusl',
      main_state: 'customer',
      name: 'CUSTOMER',
      type: 'link',
      icon: '',
      children: [],
      p_type: Permission_TYPE.CUSTOMER//can you change

    }],
  },
  {
    label: 'USER APPROVAL',
    main: [{
      state: 'approval',
      short_label: 'cusl',
      main_state: 'user',
      name: 'USER APPROVAL',
      type: 'link',
      icon: '',
      children: [],
      p_type: Permission_TYPE.USER_APPROVE//can you change

    }],
  },

  {
    label: 'USER',
    main: [{
      state: 'list',
      short_label: 'usr',
      main_state: 'user',
      name: 'USER',
      type: 'link',
      icon: '',
      children: [],
      p_type: Permission_TYPE.USER//can you change
    }],
  },
  // {
  //   label: 'USER',
  //   main: [{
  //     state: 'list',
  //     short_label: 'userlh',
  //     main_state: 'grouppermission',
  //     name: 'PERMISSION',
  //     type: 'link',
  //     icon: 'ti-layout-media-right',
  //     p_type: Permission_TYPE.PERMISSION
  //   }],
  // },
];


@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/menu-items/menu-items.ts